import { useEffect } from "react";
import { useBlocker } from "react-router";

export function useAdminUnsavedChanges(active: boolean) {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => (
    active
    && currentLocation.pathname + currentLocation.search
      !== nextLocation.pathname + nextLocation.search
  ));

  useEffect(() => {
    if (!active) return;
    const preventUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", preventUnload);
    return () => window.removeEventListener("beforeunload", preventUnload);
  }, [active]);

  return blocker;
}
